import classNames from "classnames";
import React from "react";

export type PillSizes = "normal" | "larger";

interface Props {
  color: "blue" | "purple" | "gray" | "darkgray" | "pink" | "green" | "orange"
  label: string
  size?: PillSizes
  title?: string
  style?: React.CSSProperties
  onClick?: () => void
}

const Pill = ({ color, label, style, size = "normal", title, onClick }: Props) => {
  const cssClasses = classNames("s1_pill", `${color}-pill`, {
    larger: size === "larger",
  });

  return (
    <div
      className={cssClasses}
      style={{
        cursor: onClick ? "pointer" : undefined,
        ...style
      }}
      onClick={onClick}
      title={title}>
      {label}
    </div>
  );
};

export default Pill;